import { CustomPermissionManagerProvider } from '@efex-services/auth/role-permission/PermissionRoleContext';
import { Alert } from '@efexteam/components';
import { ColorsNeutral200 } from '@efexteam/design-tokens';
import { RoleId, RoleIds } from '@efexteam/permission-manager';
import { Card, CardContent, CardHeader, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import RoleSelector from '../roleSelctor';
import UserActions from './components/userActions';
import RoleCardStyles from './RoleCard.style';
import { IRoleCard } from './types';

const RoleCard = ({ roleId, setRoleId }: IRoleCard) => {
  const { t } = useTranslation();

  return (
    <Grid item xs={12} md={6}>
      <Card>
        <CardHeader
          title={t('editMmbRoleTitle')}
          sx={{
            borderBottom: `1px solid ${ColorsNeutral200}`,
          }}
        />
        <CardContent>
          <RoleSelector roleId={roleId} setRoleId={setRoleId} />
          {roleId === RoleIds.PAYMENT_ANALYST && (
            <Alert className={RoleCardStyles.infoAlert} severity="info">
              {t('roleConfiguratorDisclaimer')}
            </Alert>
          )}
          <CustomPermissionManagerProvider roleId={roleId as RoleId}>
            <UserActions />
          </CustomPermissionManagerProvider>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default RoleCard;
